import { Checkbox } from "@/shared/components/common/Checkbox";
import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import type { CheckboxOption, FilterComponent } from "../filter.types";
import List from "../../common/List";
import { useClientSearchParams } from "@/shared/hooks/useClientSearchParams";
import PhosphorIcon from "../../common/PhosphorIcon";
import { isString } from "@/shared/libs/type-utils";
import Image from "next/image";

const TimeScheduleFilter: FilterComponent<CheckboxOption[]> = ({
  value,
  applyFilter,
  currentValue,
  filterName,
}) => {
  const clientSearchParams = useClientSearchParams();
  const currentState = currentValue ?? clientSearchParams.get(filterName) ?? "";
  const DAYTIMES = ["6-12", "12-18", "18-24", "24-6"];

  return (
    <Flex
      justifyContent={"evenly"}
      alignItems={"center"}
      className="w-full max-md:my-2"
    >
      <List
        items={value}
        renderItems={({ label, name, icon }, index) => (
          <Flex alignItems={"start"} gap={"1"}>
            <Checkbox hidden checked={currentState.includes(name)} />

            <Flex
              justifyContent={"evenly"}
              alignItems={"center"}
              direction={"col"}
              className={`w-14 h-20 ring-1 ring-ring bg-background hover:bg-muted dark:hover:bg-muted/10 py-2 px-3 rounded-lg cursor-pointer hover:shadow-1 transition ease-easeInOutCirc duration-100 group ${
                currentState.includes(name) &&
                "shadow-1 bg-muted dark:bg-muted/5"
              }`}
              onClick={() =>
                currentState.includes(name)
                  ? applyFilter("")()
                  : applyFilter(name)()
              }
            >
              {icon && (
                <Typography
                  className={`group-hover:scale-105 group-hover:text-foreground transition ease-easeInOutCirc duration-100 ${
                    currentState.includes(name)
                      ? "text-foreground"
                      : "text-grayColor-foreground"
                  }`}
                >
                  {isString(icon) ? (
                    <Image
                      src={icon}
                      className="w-7 h-7"
                      width={100}
                      height={100}
                      alt="airline"
                    />
                  ) : (
                    <PhosphorIcon
                      name={icon.name as keyof typeof PhosphorIcon}
                      size={20}
                      className={icon.classNames}
                    />
                  )}
                </Typography>
              )}
              <Typography
                className={`group-hover:text-foreground ${
                  currentState.includes(name)
                    ? "text-forground"
                    : "text-grayColor-foreground"
                } transition ease-easeInOutCirc duration-100`}
              >
                {label}
              </Typography>
              <Typography
                className={`group-hover:text-foreground text-xs ${
                  currentState.includes(name)
                    ? "text-forground"
                    : "text-grayColor-foreground"
                } transition ease-easeInOutCirc duration-100`}
              >
                {DAYTIMES[index]}
              </Typography>
            </Flex>
          </Flex>
        )}
      />
    </Flex>
  );
};

export default TimeScheduleFilter;
